module.exports = __webpack_public_path__ + "static/media/dansa.293ca718.jpg";